import { useState } from "react";
import { api } from "../../../../../../../../../utility/api";

export const TancadasApi = () => {
    const [cargando, setCargando] = useState(false);

    const getTancadas = async (params) => {
        try {
            setCargando(true);
            const response = await api.get("tancadas/listado_tancadas", params);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const crearTancada = async (data) => {
        try {
            setCargando(true);
            const response = await api.post("tancadas", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const deleteTancada = async (id) => {
        try {
            setCargando(true);
            const response = await api.eliminar(`tancadas/${id}`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getTancadas,
        crearTancada,
        deleteTancada,

        cargando,
    };
};
